export default __webpack_public_path__ + "static/media/14_ideal.bb1f691a.svg";